var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-dialog modal-xl" }, [
    _c("div", { staticClass: "modal-content border-0 shadow-lg" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h4", { staticClass: "modal-title fw-bold" }, [
          _vm._v(
            "\n                Products for " +
              _vm._s(_setup.monthName) +
              " " +
              _vm._s(_setup.year) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "btn-close",
          attrs: { type: "button", "aria-label": "Close" },
          on: {
            click: function ($event) {
              return _vm.$emit("hide-modal")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body p-0 pb-3" }, [
        _setup.productData
          ? _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                {
                  staticClass:
                    "table table-hover align-middle mb-0 text-nowrap",
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _setup.productData.length === 0
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass:
                                  "text-center py-4 text-muted small",
                                attrs: { colspan: "7" },
                              },
                              [
                                _vm._v(
                                  "\n                            No transaction logs available for this period.\n                        "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_setup.productData, function (data, k) {
                        return _c("tr", { key: k }, [
                          _c("td", { staticClass: "ps-3 fw-medium" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "text-decoration-none text-primary",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _setup.handleNavigationToOrder(
                                      data.orderId
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(data.title) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-end font-monospace small" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.quantity) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-end font-monospace small" },
                            [
                              _vm._v(
                                "\n                            £" +
                                  _vm._s(_setup.formatCurrency(data.net)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-end font-monospace small" },
                            [
                              _vm._v(
                                "\n                            £" +
                                  _vm._s(_setup.formatCurrency(data.tax)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-end font-monospace small" },
                            [
                              _vm._v(
                                "\n                            £" +
                                  _vm._s(_setup.formatCurrency(data.gross)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-end font-monospace small" },
                            [
                              _vm._v(
                                "\n                            £" +
                                  _vm._s(_setup.formatCurrency(data.shipping)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass:
                                "text-end font-monospace small fw-bold pe-3",
                            },
                            [
                              _vm._v(
                                "\n                            £" +
                                  _vm._s(
                                    _setup.formatCurrency(
                                      Number(data.gross) + Number(data.shipping)
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ])
          : _c("div", { staticClass: "p-5 text-center my-3" }, [_vm._m(1)]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "ps-3" }, [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Quantity")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Net")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("VAT")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Gross")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Shipping")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-end" }, [_vm._v("Total")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "spinner-border text-secondary",
        attrs: { role: "status" },
      },
      [
        _c("span", { staticClass: "visually-hidden" }, [
          _vm._v("Loading transactional data..."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }